module.exports = __webpack_public_path__ + "static/014-f9fa839e52317afd62ae292dfe797cf7.jpg";